module.exports = __webpack_public_path__ + "static/media/sarah.259e8d42.jpg";